import React from 'react'
import { P1, P2 } from './EventStyledComponents'

const BriefDescription = ({ activity }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', width: '370px' }}>
      <div>
        <P1>Categories:</P1>
        <P1>Goal:</P1>
        <P1>Role:</P1>
        <P1>Duration Min:</P1>
        <P1>Duration Max:</P1>
      </div>

      <div style={{ marginLeft: '42px' }}>
        <P2>-</P2>
        <P2>-</P2>
        <P2>-</P2>
        {activity.duration_min ? <P2>{activity.duration_min}</P2> : <P2> - </P2>}
        {activity.duration_max ? <P2>{activity.duration_max}</P2> : <P2> - </P2>}

      </div>
    </div>
  )
}

export default BriefDescription
